import { Fragment, useMemo, useState } from "react";
import { FormGroup, Label } from "reactstrap";
import Select from "react-select";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import DataTable from "../../Components/DataTable";
import { API_BASE_URL } from "../../api/api";
import { getInfluencerBonusColumns } from "../../Components/influencerBonus/InfluencerBonusColumns";
import { InfluencerBonusModal } from "../../Components/influencerBonus/InfluencerBonusModal";
import { PageHeader } from "../../Components/common/PageHeader";

export const InfluencerBonusList = () => {
  const { getData } = useDataFetch();

  const [filters, setFilters] = useState({ settlementId: "" });
  const [appliedFilters, setAppliedFilters] = useState({ settlementId: "" });
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedBonus, setSelectedBonus] = useState(null);

  const closeModal = () => {
    setModalOpen(false);
    setSelectedBonus(null);
  };

  const { data: settlementsSummary } = getData(
    ["settlements-summary"],
    "/settlements/summary"
  );

  const settlementOptions = useMemo(
    () =>
      settlementsSummary?.data
        ?.filter((s) => s.type === "INFLUENCER_BONUS")
        .map((s) => {
          // Extraer solo la parte de fecha sin conversión de zona horaria
          const start = s.period.start.split('T')[0].split('-').reverse().join('/');
          const end = s.period.end.split('T')[0].split('-').reverse().join('/');
          return {
            value: s.id,
            label: `${start} - ${end}`,
          };
        }) || [],
    [settlementsSummary]
  );

  const { data, isLoading } = getData(
    ["influencer-bonuses", appliedFilters, pagination],
    "/settlements/influencer-bonuses",
    {},
    {
      page: pagination.pageIndex + 1,
      limit: pagination.pageSize,
      ...(appliedFilters.settlementId
        ? { id: appliedFilters.settlementId }
        : {}),
    }
  );

  const columns = useMemo(
    () => getInfluencerBonusColumns(setSelectedBonus, setModalOpen),
    []
  );

  const handleSearch = () => {
    setPagination((prev) => ({ ...prev, pageIndex: 0 }));
    setAppliedFilters({
      settlementId: filters.settlementId || "",
    });
  };

  const handleGenerateExcel = () => {
    const params = new URLSearchParams();
    params.set("page", pagination.pageIndex + 1);
    params.set("limit", pagination.pageSize);
    if (appliedFilters.settlementId)
      params.set("id", appliedFilters.settlementId);

    window.open(
      `${API_BASE_URL}/settlements/report/excel/influencer-bonus?${params.toString()}`,
      "_blank"
    );
  };

  return (
    <Fragment>
      <PageHeader
        title="Bonos de influencers"
        crumbs={[{ label: "Liquidaciones" }, { label: "Bonos de influencers" }]}
        actions={
          <button type="button" className="btn btn-outline-primary btn-sm d-flex align-items-center gap-1" onClick={handleGenerateExcel}>
            <i className="ri-file-excel-2-line" /> Excel
          </button>
        }
      />

      <DataTable
        data={data?.data ?? []}
        total={data?.pagination?.total ?? 0}
        pagination={pagination}
        setPagination={setPagination}
        columns={columns}
        progressPending={isLoading}
        emptyMessage="No hay liquidaciones de bono influencer para mostrar."
        filters={
          <div className="d-flex align-items-end gap-2 flex-wrap w-100">
            <FormGroup className="mb-0" style={{ minWidth: 240 }}>
              <Label className="form-label mb-1">Periodo</Label>
              <Select
                classNamePrefix="react-select"
                isClearable
                placeholder="Selecciona"
                options={settlementOptions}
                value={
                  settlementOptions.find(
                    (opt) => opt.value === filters.settlementId
                  ) || null
                }
                onChange={(option) =>
                  setFilters((prev) => ({
                    ...prev,
                    settlementId: option ? option.value : "",
                  }))
                }
              />
            </FormGroup>
            <button type="button" className="btn btn-primary btn-sm" onClick={handleSearch}>
              <i className="ri-search-line me-1" /> Buscar
            </button>
          </div>
        }
      />

      <InfluencerBonusModal
        isOpen={modalOpen}
        toggle={closeModal}
        bonus={selectedBonus}
      />
    </Fragment>
  );
};
